/*
 * @Author: cgh
 * @Date: 2022-08-01 10:49:32
 * @LastEditors: zxf
 * @LastEditTime: 2023-04-10 18:01:28
 * @Description: file content
 */

import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;

export const pgxmManageService = {
  // 查询
  query: (params) => { return axios.get(`${iffApi}/xfpg/pgxm`, { params: params }); },

  // 查询
  getPgyj: () => { return axios.get(`${iffApi}/xfpg/pgxm/pgyj`); },

  // 新增
  save: (fd) => { return axios.post(`${iffApi}/xfpg/pgxm`, fd); },

  // 修改
  update: (id, fd) => { return axios.put(`${iffApi}/xfpg/pgxm/${id}`, fd); },

  // 删除
  delete: (id) => { return axios.delete(`${iffApi}/xfpg/pgxm/${id}`); },

  // 详情
  getDetail: (id) => { return axios.get(`${iffApi}/xfpg/pgxm/${id}`); },

  // 导出
  export: (params) => { return axios.get(`${iffApi}/xfpg/pgxm/export`, { responseType: 'blob', params }); },

  // 申请修改
  sqxg: (id) => { return axios.put(`${iffApi}/xfpg/pgxm/sqxg/${id}`); },

  // 重新评估
  cxpg: (id) => { return axios.get(`${iffApi}/xfpg/pgbg/cxpg/${id}`); },

  // 评估仪器列表查询
  pgyqByXmid: (id) => { return axios.get(`${iffApi}/xfpg/pgxm/${id}/pgyq`); },

  // 更新评估项目的评估仪器
  updatePgyq: (id, fd) => { return axios.put(`${iffApi}/xfpg/pgxm/${id}/pgyq`, fd); },

  // 高位问题列表查询(项目)
  gwwtXmQuery: (id) => { return axios.get(`${iffApi}/xfpg/gwwt/${id}`); },

  // 高位问题列表查询（全局）
  gwwtListQuery: () => { return axios.get(`${iffApi}/xfpg/gwwt/gwwtlb`); },

  // 保存高位问题
  gwwtSave: (id, fd) => { return axios.post(`${iffApi}/xfpg/gwwt/save/${id}`, fd); },

  // 评估明细列表查询
  pgmxQuery: (id, params) => { return axios.get(`${iffApi}/xfpg/pgxm/${id}/pgmx`, { params: params }); },

  // 签章
  qz: (id) => { return axios.post(`${iffApi}/xfpg/pgxm/${id}/qz`); },

  // 盖章
  gz: (id) => { return axios.post(`${iffApi}/xfpg/pgxm/${id}/gz`); },

  // 生成评估报告
  scbg: (id) => { return axios.get(`${iffApi}/xfpg/pgbg/${id}/zsbg`); },

  // 生成临时报告
  sclsbg: (id) => { return axios.get(`${iffApi}/xfpg/pgbg/${id}/lsbg`); },

  // 加盖公章
  jggz: (id) => { return axios.post(`${iffApi}/xfpg/pgxm/${id}/jggz`); },

  // 是否需要签章和签章
  isNeedQGz: (id) => { return axios.get(`${iffApi}/xfpg/pgxm/${id}/isNeedQGz`); },

  // 获取可转移用户列表
  getTranslateUsers: (xmId) => { return axios.get(`${iffApi}/xfpg/pgxm/xmusers/${xmId}`); },

  // 项目转移
  translate: (fd) => { return axios.post(`${iffApi}/xfpg/pgxm/translate`, fd); }

};
